import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-select-options', (editor, opts = {}) => {
  const config = {
    blocks: [
      'selectComponent',
    ],
    name: 'selectComponent',
    stylePrefix: 'gjs-',
    labelComponent: 'Seleccion',
    defText: 'Sample',
    category: 'Formularios',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
